export const CA = "UNbT74tbUhtPM8YWmBTbWk9JxbAeNQCQP89jjWnpump";
export const DEX_URL = "https://dexscreener.com/solana/bhceyicmpsw8wmi2rfd1c13s6xbaojvezt1yncyrrwhp";
export const DEX_EMBED = `${DEX_URL}?embed=1&theme=dark&trades=0&info=0`;
export const TG_URL = "https://t.me/MERRY_SOLMAS";
export const X_URL = "https://x.com/MERRY_SOLMAS";
export const TARGET_DATE_UTC = Date.UTC(2026, 11, 25, 0, 0, 0);
